import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_FONT } from '../../../../theme/customizer-tokens';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled(Text)`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${CUST.textMuted};
`;

/** Underline field — grey by default, orange while focused or filled. */
export const Field = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  height: 72px;
  padding: 12px 24px;
  width: 100%;
  border-bottom: 1px solid ${({ $active }) => ($active ? CUST.accent : CUST.textMuted)};
  transition: border-color ${CUST_ANIM.INTERACT_MS}ms ease;
`;

export const Input = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: ${CUST_FONT};
  font-size: 26px;
  font-weight: 300;
  line-height: 1.2;
  color: ${CUST.white};

  &::placeholder {
    color: ${CUST.textMuted};
  }
`;